<div class="outer-content">
<div role="dialog" id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true" class="wh-auto">
  <div class="float-left bg-white card-background wh-auto">
    <form [formGroup]="doctorForm" autocomplete="off" role="form" class="fieldHeight">
      <app-content-top-nav [visibleSaveProgress]="!isHOView" [visibleBackNav]='true' [enableBackNav]='true'></app-content-top-nav>
      <div  [ngClass]="utilityServiceForMedicalService.currentUWScreenName === 'dependant'? 
      'col-md-12 clear-all dep-title-wrapper':'col-md-12 clear-all title-wrapper'">
        <h1 class="title-text custom-header-h2 responsive-text-8" id="doctorDetails-header" [innerHTML]="contentData.header"></h1>
      </div>
      <div class="col-md-12 clear-all flex-container">
        <p class="If-you-decide-to-app" id="doctorDetails-introduction" [innerHTML]="contentData.introduction">
        </p>
      </div>
      <div  [ngClass]="utilityServiceForMedicalService.currentUWScreenName === 'dependant'? 
      'col-md-12 clear-all content-wrapper dep-content-container':'col-md-12 clear-all content-wrapper content-container'"> <!--class="col-md-12 clear-all content-wrapper content-container"-->
        <ul class="list-tick">
        <ng-container *ngFor="let list of contentData.details let i=index">
          
            <li alt="" class="paraText-info" [id]="'doctorDetails-'+list.code+'li'" >
              <span  [id]="'doctorDetails-'+list.code">{{list.text}}
                <!-- <strong id="doctorDetails-referenceNum" *ngIf="list.referenceNum">{{list.referenceNum}}</strong> -->
                <!-- <span id="'doctorDetails-dot'" *ngIf="list.dot">{{list.dot}}</span> -->
              </span>

            </li>
           
          
         <!-- <div class="col-md-12 padding-left-0">
            <div class="col-md-1 tick-blue">
              <img id="'img-tick-copy-first-'+i" alt="tick" src="assets/images/tick copy.png" />
            </div>
            <div class="col-md-11 margin-bottom-25">
              <span class="paraText-info" [id]="'doctorDetails-'+list.code">{{contentData.details[0].text}}
                <strong id="doctorDetails-referenceNum" *ngIf="list.referenceNum">{{list.referenceNum}}</strong>
                <span id="'doctorDetails-dot'" *ngIf="list.dot">{{list.dot}}</span>
              </span>
            </div>
          </div>-->
        </ng-container>
      </ul>
      </div>

      <div class="col-md-12 underline margin-top"></div>
      <div class="col-md-12 clear-all bottom-container">
          <div class="float-left">
              <app-save *ngIf="!isHOView"  [location]="'contentBottom'"></app-save>
          </div>
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
        </div>
      </div>
    </form>
  </div>
</div>
</div>
